exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#social-share{padding:6.5rem 0;width:100%}#share-links{list-style:none;display:block;background:#fff;position:relative}.share-li{display:inline-block}.share-li.mid{margin:0 .25em;-webkit-transition:all .5s ease-out;transition:all .5s ease-out}.share-label,.share-li a{font-weight:700;text-decoration:none;text-transform:uppercase;font-size:1rem;cursor:pointer}#share-links .animate .share-li.mid{margin:0 1.6em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib?{"config":{"path":"postcss.config.js"}}!./~/sass-loader/lib/loader.js!./src/styles/_social-share.scss
// module id = 408
// module chunks = 1